import { type RoleQueries, defRoleQueries } from '@kizen/query/role';
import AxiosService from '__services/AxiosService';

const queries: RoleQueries = defRoleQueries(AxiosService);

export const roleHistoryQuery: RoleQueries['roleHistoryQuery'] =
  queries.roleHistoryQuery;

export const rolesQuery: RoleQueries['rolesQuery'] = queries.rolesQuery;
